import React, { useEffect, useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { config } from '@app/config';
import gtmTracking from '@app/utils/gtmTracking';
import { getDataFloatButton } from '@app/components/JobFloatingButton/action';
import { RewardWrapper, CloseButton } from './styled';
import { ENABLE, IMAGE, URL } from './constant';

const JobFloatingButton = memo((props) => {
  const dispatch = useDispatch();

  const { auth, isClient } = props;
  const [rewardIconCookie, showRewardIconCookie] = useState(false);
  const { loaded, data } = useSelector((state) => state.jobFloatingButton);

  const isShow = data ? data[ENABLE] && data[IMAGE] && data[URL] : false;

  const handleRewardIconHide = () => {
    gtmTracking('floating_button', 'close_floating_button', 'click_close_on_floating_button', {
      page_type: 'job_homepage',
      account_id: auth?.account_id || 'none',
      finger_print: Cookies.get('ctfp') || 'none',
    });
    Cookies.set('hideReferralIcon', true, config.cookieConfig);
    showRewardIconCookie(false);
  };

  useEffect(() => {
    if (!Cookies.get('hideReferralIcon')) {
      showRewardIconCookie(true);
      dispatch(getDataFloatButton());
    }
  }, [auth?.loaded]);

  if (!(isClient && rewardIconCookie && loaded && isShow)) return null;

  return (
    <RewardWrapper>
      <a
        href={data[URL]}
        onClick={() => {
          gtmTracking('floating_button', 'floating_button', 'click', {
            page_type: 'job_homepage',
            account_id: auth?.account_id || 'none',
            finger_print: Cookies.get('ctfp') || 'none',
          });
        }}
        rel="nofollow"
      >
        <img src={data[IMAGE]} alt="uu dai cho tot" />
      </a>
      <CloseButton onClick={() => handleRewardIconHide()}>
        <div className="icon">×</div>
      </CloseButton>
    </RewardWrapper>
  );
});

JobFloatingButton.propTypes = {
  auth: PropTypes.object.isRequired,
  isClient: PropTypes.bool,
};

JobFloatingButton.defaultProps = {
  isClient: false,
};

export default JobFloatingButton;
